export type MermaidLightboxPayload = {
  svgHtml: string
  source?: string
}

type Listener = (payload: MermaidLightboxPayload | null) => void

const listeners = new Set<Listener>()

export function subscribeMermaidLightbox(listener: Listener): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function openMermaidLightbox(payload: MermaidLightboxPayload): void {
  for (const listener of listeners) {
    listener(payload)
  }
}

export function closeMermaidLightbox(): void {
  for (const listener of listeners) {
    listener(null)
  }
}
